import { api } from "./api";

/** Profile + password endpoints used by the dashboard Account tab. */
export async function updateProfile({ name, country }) {
  const body = {};
  if (name !== undefined) body.name = name;
  if (country !== undefined) body.country = country;
  const { data } = await api.patch("/auth/profile", body);
  return data;
}

export async function changePassword(currentPassword, newPassword) {
  const { data } = await api.post("/auth/change-password", {
    current_password: currentPassword,
    new_password: newPassword,
  });
  return data;
}

/** Notifications API. */
export async function fetchNotifications(limit = 50) {
  const { data } = await api.get("/notifications", { params: { limit } });
  return data;
}

export async function markNotificationsRead(ids = []) {
  const { data } = await api.post("/notifications/mark-read", { ids });
  return data;
}

export async function deleteNotification(id) {
  const { data } = await api.delete(`/notifications/${id}`);
  return data;
}
